var map = {
	"./404.svg": "sEM+",
	"./bug.svg": "SVqS",
	"./chart.svg": "RjYk",
	"./clipboard.svg": "KO/S",
	"./component.svg": "s2cW",
	"./dashboard.svg": "BCGP",
	"./documentation.svg": "zUKd",
	"./edit.svg": "ql+d",
	"./excel.svg": "OLl3",
	"./eye-open.svg": "no6o",
	"./eye.svg": "4wdf",
	"./form.svg": "sTIr",
	"./international.svg": "SBEl",
	"./link.svg": "KgwQ",
	"./list.svg": "vuHp",
	"./message.svg": "G2zY",
	"./password.svg": "QjmH",
	"./peoples.svg": "TgHK",
	"./user.svg": "VdD3"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 10